/**
 * Table of Contents — collapsible toggle.
 *
 * Toggles the `aria-expanded` attribute on `.toc-collapsible__toggle` buttons
 * and flips the `.toc-collapsible__icon` text between ▼ and ▲.
 */
export function initToc() {
  document.querySelectorAll('.toc-collapsible__toggle').forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isExpanded));

      const icon = toggle.querySelector('.toc-collapsible__icon');
      if (icon) icon.textContent = isExpanded ? '▼' : '▲';
    });
  });
}
